import { render, staticRenderFns } from "./PortalAccessModal.vue?vue&type=template&id=6f9fa56a&"
import script from "./PortalAccessModal.vue?vue&type=script&lang=js&"
export * from "./PortalAccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f9fa56a')) {
      api.createRecord('6f9fa56a', component.options)
    } else {
      api.reload('6f9fa56a', component.options)
    }
    module.hot.accept("./PortalAccessModal.vue?vue&type=template&id=6f9fa56a&", function () {
      api.rerender('6f9fa56a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/modals/PortalAccessModal.vue"
export default component.exports